import React, { useEffect, useMemo, useState, memo } from "react";
import { Icon } from "@me8eon/icons";
import { useNexthinkContext } from "./nexthink.context";

type SystemCheckMessageListProps = {
    iconName?: string;
    iconColor?: string;
    effectEnd?: () => void;
    alreadyRan?: boolean;
};

export const SystemCheckMessageList: React.FC<SystemCheckMessageListProps> = ({
    iconName = "tick_small",
    iconColor = "#34C759",
    effectEnd,
    alreadyRan,
}) => {
    const { localT } = useNexthinkContext();
    const [visibleCount, setVisibleCount] = useState(1);
    const messages = useMemo(
        () => [
            localT("chatBot.nexthinkIntegration.smartSolution.systemCheckMessages.recentlyStarted"),
            localT("chatBot.nexthinkIntegration.smartSolution.systemCheckMessages.appsHealthy"),
            localT("chatBot.nexthinkIntegration.smartSolution.systemCheckMessages.driveSpace"),
            localT("chatBot.nexthinkIntegration.smartSolution.systemCheckMessages.noCrashes"),
            localT("chatBot.nexthinkIntegration.smartSolution.healthCheckNoIssue")
        ],
        [localT],
    );

    useEffect(() => {
        setVisibleCount(1);
        if (alreadyRan) setVisibleCount(messages.length);
        if (messages.length <= 1) return;
        const intervalId = window.setInterval(() => {
            setVisibleCount((current) => {
                if (current >= messages.length) {
                    window.clearInterval(intervalId);
                    if (effectEnd) effectEnd();
                    return current;
                }
                return current + 1;
            });
        }, 800);

        return () => window.clearInterval(intervalId);
    }, [messages]);

    return (
        <div className="system-check-message-list" aria-live="polite">
            <ul className="system-check-message-list__items">
                {messages.slice(0, visibleCount).map((msg, index) => (
                    <li
                        key={`${msg}-${index}`}
                        className="system-check-message-list__item"
                        style={{ animationDelay: `${index * 0.15}s` }}
                    >
                        {index < 4 && (<Icon size="small" name={iconName} themedColor={iconColor} />)}
                        <span
                            dangerouslySetInnerHTML={{
                                __html: msg
                            }}
                        />
                    </li>
                ))}
            </ul>
        </div>
    );
};

export default memo(SystemCheckMessageList);
